import React from 'react';
import { EventIcon, RepoIcon } from '@src/Components/Icons';

import styles from './TimelineDetail.module.scss';

interface TimelineDetailProps {
  date: string;
  countLocation: number;
  event: number | string;
  repo: number | string;
}

const TimelineDetail: React.FC<TimelineDetailProps> = ({
  date = 'June 2023',
  countLocation = 0,
  event = 0,
  repo = 0
}) => {
  return (
    <article data-testid="timeline-detail" className={styles['Container']}>
      <div className={styles['Subtitle']}>Map records on {date}</div>
      <div className={styles['Title']}>Total {countLocation} Location</div>
      <div className={styles['Description']}>
        <EventIcon color="#fff" /> Event ({event}) ∙
      </div>
      <div className={styles['Description']}>
        <RepoIcon color="#fff" /> Mythic Repo ({repo}) ∙
      </div>
    </article>
  );
};

export default TimelineDetail;
